module.exports = __webpack_public_path__ + "img/27_52.f1318f09.png";